module.exports = __webpack_public_path__ + "img/icon_f.9b5bb01d.png";